import { all, call, put, select, takeEvery } from "redux-saga/effects";

import { ToastContent, getToastContent } from "constants/toasts";
import { EventPlace, trackEngagement, trackGTMEvent } from "helpers/analytics";
import { isActive } from "helpers/subscription";
import { ApiManager } from "services/api";
import { SubscriptionActions, selectCurrentSubscription } from "store/entities/subscriptions";
import { ToastAutoHideDelay, ToastVariant, ToastsActions } from "store/features/toasts";
import { IActionWithPayload } from "store/helper";

import { BillingActions } from "../billing/actions";

import { CreditCardActionNames, CreditCardActions } from "./actions";
import { IAddCreditCardFailurePayload, IAddCreditCardRequestPayload } from "./interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addCreditCard(action: IActionWithPayload<string, IAddCreditCardRequestPayload>) {
  const { token, newSubscription } = action.payload;
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const subscription = yield select(selectCurrentSubscription);
  const hasActiveSubscription = isActive(subscription);
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const response = yield call(ApiManager.billingApi.update, token);
  if (response.result) {
    if (hasActiveSubscription) {
      if (newSubscription) {
        // use-case: agent enters credit card during trial
        // and we should update number of purchased agents
        // (in trial default is "1")
        yield put(SubscriptionActions.update({ value: newSubscription }));
      }
      trackGTMEvent("subscribeAccount");
    } else {
      // @ts-expect-error TS(2322)
      yield put(SubscriptionActions.create({ value: newSubscription }));
    }

    yield put(BillingActions.fetchBillingInfoSuccess(response.result));
    yield put(CreditCardActions.addCreditCardSuccess());
    yield call(trackEngagement, "Account details: Updated billing details", EventPlace.AccountDetails);
  } else {
    yield put(CreditCardActions.addCreditCardFailure({ error: response.error?.error?.message }));
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addCreditCardSuccess() {
  // @ts-expect-error TS(7057): 'yield' expression implicitly results in an 'any' ... Remove this comment to see the full error message
  const subscription = yield select(selectCurrentSubscription);
  const { agents, pricePerAgent } = subscription;

  // TODO remove after product days
  // @ts-expect-error TS(2339): Property 'LiveChatWidget' does not exist on type '... Remove this comment to see the full error message
  if (window.LiveChatWidget) {
    // @ts-expect-error TS(2339): Property 'LiveChatWidget' does not exist on type '... Remove this comment to see the full error message
    window.LiveChatWidget.call("trigger_sales_tracker", {
      trackerId: "UA4g1rpVwJ0wnOrBvjYRD9IlutegoJLe",
      orderPrice: (agents * pricePerAgent) / 100,
    });
  }
  yield put(
    ToastsActions.createToast({
      content: getToastContent(ToastContent.BILLING_DETAILS_UPDATED),
      variant: ToastVariant.Success,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* addCreditCardFailure(action: IActionWithPayload<string, IAddCreditCardFailurePayload>) {
  const { error } = action.payload;

  yield put(
    ToastsActions.createToast({
      content: error || getToastContent(ToastContent.BILLING_DETAILS_UPDATE_FAILURE),
      variant: ToastVariant.Error,
      autoHideDelayTime: ToastAutoHideDelay.Infinite,
    })
  );
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* creditCardSaga() {
  yield all([
    takeEvery(CreditCardActionNames.ADD_CREDIT_CARD_REQUEST, addCreditCard),
    takeEvery(CreditCardActionNames.ADD_CREDIT_CARD_SUCCESS, addCreditCardSuccess),
    takeEvery(CreditCardActionNames.ADD_CREDIT_CARD_FAILURE, addCreditCardFailure),
  ]);
}
